
import { Vue, Component } from 'vue-property-decorator';
import * as echarts from 'echarts';

@Component({})
export default class EchartsModal extends Vue {
  visible = false;

  title = '';

  width = 1300;

  onCancel() {
    this.visible = false;
  }

  onOk() {
    this.visible = false;
  }


  getChart1Data() {
    this.visible = true;

    const communicateData = [
      { value: Math.floor(Math.random() * 1000) + 1, name: '考虑中' },
      { value: Math.floor(Math.random() * 1000) + 1, name: '暂不续费' },
      { value: Math.floor(Math.random() * 1000) + 1, name: '续签成功' },
    ];
    const reasonData = [
      { value: Math.floor(Math.random() * 1000) + 1, name: '建联 从未建联' },
      { value: Math.floor(Math.random() * 1000) + 1, name: '效果 团购订单少' },
      { value: Math.floor(Math.random() * 1000) + 1, name: '效果 电话客资少' },
      { value: Math.floor(Math.random() * 1000) + 1, name: '市场 架道竞争影响' },
      { value: Math.floor(Math.random() * 1000) + 1, name: '效果客有效性差' },
      { value: Math.floor(Math.random() * 1000) + 1, name: '其他 自身资金紊张' },
      { value: Math.floor(Math.random() * 1000) + 1, name: '其他 合伙人/家人不同意' },
    ];

    const communicateOption = {
      title: {
        top: '10%',
        text: '沟通情况',
        left: 'center',
      },
      tooltip: {
        trigger: 'item',
      },
      legend: {
        top: '5%',
        orient: 'vertical',
        right: 10,
        itemGap: 5, // 默认 10
      },
      series: [
        {
          name: '沟通情况',
          type: 'pie',
          radius: '40%',
          center: ['50%', '55%'], // 第一个值是水平居中，第二个值控制垂直位置
          label: {
            formatter: '{d}%',
            rich: {
              time: {
                fontSize: 10,
                color: '#999',
              },
              name: {
                fontSize: 10,
                color: '#999',
              },
            },
          },
          data: communicateData,
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)',
            },
          },
        },
      ],
    };
    const reasonOption = {
      title: {
        top: '10%',
        text: '暂不续费原因',
        left: 'center',
      },
      tooltip: {
        trigger: 'item',
      },
      legend: {
        top: '5%',
        orient: 'vertical',
        right: 10,
        itemGap: 5, // 默认 10
      },

      series: [
        {
          name: '暂不续费原因',
          type: 'pie',
          radius: '40%',
          center: ['50%', '55%'], // 第一个值是水平居中，第二个值控制垂直位置
          label: {
            formatter: '{d}%',
            rich: {
              time: {
                fontSize: 10,
                color: '#999',
              },
              name: {
                fontSize: 10,
                color: '#999',
              },
            },
          },
          data: reasonData,
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)',
            },
          },
        },
      ],
    };
    this.$nextTick(() => {
      this.echartsInit('communicate', communicateOption);
      this.echartsInit('reason', reasonOption);
    });
  }

  getFormatter(params: any) {
    const totals: number = 1048 + 735 + 580 + 484 + 33 + 30 + 400;
    const total = Number(params.value);
    const percent = (Number(total) / Number(totals)).toFixed(4) as unknown as number;
    return `${percent * 100}%`;
  }

  echartsInit(id: string, option: any) {
    const chart = echarts.init(document.getElementById(id));
    setTimeout(() => {
      chart && chart.setOption(option);
    }, 1000);
  }
}
